import mitt from 'mitt'

const emitter = mitt()

// Vue-2-style event bus API backed by mitt so existing $on/$off/$emit call sites keep working
export const eventBus = {
  $on: (event, handler) => emitter.on(event, handler),
  $off: (event, handler) => emitter.off(event, handler),
  $once: (event, handler) => {
    const onceHandler = (payload) => {
      emitter.off(event, onceHandler)
      handler(payload)
    }
    emitter.on(event, onceHandler)
  },
  $emit: (event, payload) => emitter.emit(event, payload),
}
